import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import ChevronLeft from 'components/assets/ChevronLeft.svg';
import Heading from 'components/atoms/Heading/Heading';
import React from 'react';
import classes from './PageHeader.qmee.module.scss';

interface PageHeaderProps {
  title: string;
  backHref?: string;
  skipTranslation?: boolean;
}

export default function PageHeader({
  title,
  backHref,
  skipTranslation,
}: Readonly<PageHeaderProps>) {
  return (
    <Card className={classes.headerCard}>
      {backHref ? (
        <A href={backHref} className={classes.backButton}>
          <ChevronLeft className={classes.backButtonArrow} />
        </A>
      ) : (
        <button onClick={() => globalThis.history.back()} className={classes.backButton}>
          <ChevronLeft className={classes.backButtonArrow} />
        </button>
      )}
      <Heading level={5} skipTranslation={skipTranslation} className={classes.headerTitle}>
        {title}
      </Heading>
    </Card>
  );
}
